import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";

export default class CreateOrganisationIndexGroupInteractor {
  private createResource: CreateResourceInteractor<IOrganisationIndexGroup>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IOrganisationIndexGroup) {
    return this.createResource.execute(
      `organisations/${model.organisationId}/index-groups`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper,
      model,
      undefined,
      false
    );
  }
}
